module.exports = __webpack_public_path__ + "img/gsb51.94846c56.png";